import SEO from "@/components/base/SEO";

export default function HomeSEO() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "http://jiarenmei.com/#organization",
        name: "韩漫画网",
        url: "http://jiarenmei.com/",
        description: "韩漫画网提供高清免费韩国漫画大全和最新热门漫画在线阅读，内容精彩画质清晰。",
        sameAs: ['http://jiarenmei.com/'],
      },
      {
        "@type": "WebSite",
        "@id": "http://jiarenmei.com/#website",
        url: "http://jiarenmei.com/",
        name: "韩漫画网",
        description: "高清免费韩国漫画大全，最新热门漫画在线阅读",
        publisher: { "@id": "http://jiarenmei.com/#organization" },
        inLanguage: "zh-CN",
      },
      {
        "@type": "WebPage",
        "@id": "http://jiarenmei.com/#webpage",
        url: "http://jiarenmei.com/",
        name: "韩漫画网 - 首页",
        isPartOf: { "@id": "http://jiarenmei.com/#website" },
        about: { "@id": "http://jiarenmei.com/#organization" },
      },
    ],
  };

  return (
    <SEO
      title="韩漫画网 - 高清免费韩国漫画大全，最新热门漫画在线阅读"
      description="韩漫画网提供高清免费韩国漫画大全和最新热门漫画在线阅读，涵盖恋爱、奇幻、动作、悬疑等多种题材，内容精彩画质清晰，满足您的阅读爱好。每日更新，免费畅读。"
      canonicalUrl="http://jiarenmei.com/"
      jsonLd={jsonLd}
      type="website"
    />
  );
}